import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconDepthSizeS from './IconDepth_size_s';

const props: CreateIconArguments = {
  l: IconDepthSizeS,
  m: IconDepthSizeS,
  s: IconDepthSizeS,
  xs: IconDepthSizeS,
  name: 'IconDepth',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
